import request from '@/utils/request'
import URL from './urlTranslator'

// 增加港口要求
export function addAirPortRequirement(data) {
  return request({
    url: URL.mdm.airPortRequirement.addAirPortRequirement,
    method: 'post',
    data
  })
}
// 根据uuid批量删除港口要求
export function batchDelAirPortRequirement(uuids) {
  const data = uuids
  // console.log('-------------------data', data)
  return request({
    url: URL.mdm.airPortRequirement.batchDelAirPortRequirement,
    method: 'delete',
    data
  })
}
// 更新港口要求
export function updateAirPortRequirement(data) {
  return request({
    url: URL.mdm.airPortRequirement.updateAirPortRequirement,
    method: 'put',
    data
  })
}
// 查询港口要求
export function queryAirPortRequirementList(params) {
  return request({
    url: URL.mdm.airPortRequirement.queryAirPortRequirementList,
    method: 'get',
    params
  })
}

